import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import "amfe-flexible";
import 'vant/lib/index.css';  // 引入 Vant 样式
import { getAppid } from '@/utils/common';  // 假设 getAppid 是获取 appid 的方法

function setFavicon(href) {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = href;
}

function updateFavicon() {
    const appid = getAppid();
    let faviconPath = '/favicon1.ico';
    if (appid == 2 || appid == 11) {
        faviconPath = '/favicon2.ico';
    }else if(appid == 3){
        faviconPath = '/favicon3.ico';
    }else if(appid == 4){
        faviconPath = '/favicon4.ico';
    }else if(appid == 5){
        faviconPath = '/favicon_5.ico';
    }else if(appid == 6){
        faviconPath = '/favicon6.ico';
    }else if(appid == 7){
        faviconPath = '/favicon7.ico';
    }else if(appid == 8){
        faviconPath = '/favicon8.ico';
    }else if(appid == 9){
        faviconPath = '/favicon9.ico';
    }else if(appid == 10){
        faviconPath = '/favicon10.ico';
    }else if(appid == 12){
        faviconPath = '/favicon12.ico';
    }else if(appid == 99){
        faviconPath = '/favicon99.ico';
    }
    setFavicon(faviconPath);
}

// 更新 favicon
updateFavicon();

import { Loading, Overlay, Field, Button, List } from 'vant';
const app = createApp(App);
const components = [Loading, Overlay, Field, Button, List];

components.forEach(component => {
    app.use(component);
});

app.use(router).mount('#app');
